// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_k-0";
export var skeletonCard = "_k-1";